var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"holds-the-iframe"},[_c('iframe',{staticClass:"frame-tickets",staticStyle:{"border":"none #000000"},attrs:{"src":"https://habeatat.b9ticketing.com/","loading":"lazy","name":"myIFrame"}})])
}]

export { render, staticRenderFns }